import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Field } from 'formik';
import _set from 'lodash/set';

import FieldRadio from '../../components/FieldRadio/FieldRadio';

import './fieldset-single-response.scss';

class FieldSetSingleResponse extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const { field, form, options } = this.props;
        const { name, value } = event.target;

        options.forEach((option) => {
            const optionName = `${field.name}.option-${option.id}`;
            if (optionName === name) {
                const values = Object.assign({}, form.values);
                values[field.name] = value;
                _set(values, name, value);
                form.setValues(values);
            }
        });
    }

    render() {
        const {
            form,
            id,
            field,
            label,
            options,
        } = this.props;
        const fieldName = field.name;
        const fieldId = id || fieldName;
        const error = form.errors[fieldName];
        const isInvalid = error !== undefined && error !== null;
        const isTouched = !!form.touched[fieldName];
        const className = classNames('fieldset-single-response', {
            'fieldset-single-response--invalid': isTouched && isInvalid,
        });
        return (
            <div
                aria-labelledby={`fieldset-${fieldId}-label`}
                className={className}
                id={`fieldset-${fieldId}`}
                role="group"
            >
                <span
                    className="fieldset-single-response__question"
                    id={`fieldset-${fieldId}-label`}
                >
                    {label}
                </span>
                <div className="fieldset-single-response__options">
                    {
                        options.map((option) => {
                            const optionName = `option-${option.id}`;
                            return (
                                <div
                                    className="fieldset-single-response__row"
                                    key={option.id}
                                >
                                    <div className="fieldset-single-response__option">
                                        <Field
                                            appearance="default"
                                            component={FieldRadio}
                                            id={`${fieldId}-${option.id}-option`}
                                            name={`${fieldName}.${optionName}`}
                                            onChange={this.handleChange}
                                            value={`${option.id}`}
                                            ariaLabelledby={`radio-${fieldId}-${option.id}-label`}
                                        />
                                    </div>
                                    <div
                                        className="fieldset-single-response__statement"
                                        id={`radio-${fieldId}-${option.id}-label`}
                                    >
                                        {option.text}
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

FieldSetSingleResponse.propTypes = {
    field: PropTypes.shape({
        name: PropTypes.string,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({}),
        ]),
    }).isRequired,
    form: PropTypes.shape({
        errors: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.shape({}),
            PropTypes.string,
        ])),
        touched: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.shape({}),
        ])),
    }).isRequired,
    label: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    options: PropTypes.arrayOf(PropTypes.shape({})),
};

FieldSetSingleResponse.defaultProps = {
    id: '',
    options: [],
};

export default FieldSetSingleResponse;
